import { Link2 } from "lucide-react";

import { Button } from "components/ui/Button";
import { useFetchHealthMailLoginDetails } from "features/results/hooks/useHealthMailLoginDetails";
import { useHealthMailLoginUrl } from "features/results/hooks/useHealthMailLoginUrl";

export const HealthmailLoginCardButton = ({ style, variant = "outline", size = "large" }) => {
  const { data: healthMailLoginUrl } = useHealthMailLoginUrl();
  const { data: healthMailLoginDetails } = useFetchHealthMailLoginDetails();

  return (
    <>
      {!healthMailLoginDetails?.token && healthMailLoginUrl?.url && (
        <Button
          as="a"
          variant={variant}
          size={size}
          style={style}
          endIcon={Link2}
          href={healthMailLoginUrl.url}
          target="_blank"
          rel="noopener noreferrer"
        >
          Connect to healthmail
        </Button>
      )}
    </>
  );
};
